import { render } from "./postitus1.vue?vue&type=template&id=7c6c95a3&scoped=true"
const script = {}

import "./postitus1.vue?vue&type=style&index=0&id=7c6c95a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6c95a3"]])

export default __exports__